<template>
  <div class="w-full pt-8 px-8 flex flex-col justify-center">
    <h1 class="text-cw-900">{{ title }}</h1>
    <h6 v-if="subtitle" :class="[{ 'mb-8': subscribers.length }, 'text-sm']">
      {{ subtitle }}
    </h6>

    <div
      v-if="!!subscribers.length"
      class="grid grid-cols-1 max-h-80 overflow-y-scroll bg-truegray-100 border border-truegray-300 p-4 rounded"
    >
      <div v-for="subscriber in subscribers" :key="subscriber.id">
        {{ subscriber.email }}
      </div>
    </div>

    <!-- Actions -->
    <div class="grid grid-cols-1">
      <div class="w-full flex items-center justify-center mt-10">
        <button
          type="button"
          :disabled="!canSubmit || thinking"
          class="btn btn-primary relative w-40 m-0"
          :class="{
            'opacity-25 cursor-not-allowed': !canSubmit,
          }"
          @click="onSubmit"
        >
          <div
            class="absolute inset-0 w-full flex justify-center items-center z-20"
          >
            <lottie v-if="thinking" :options="loadingAnimationOptions" />
          </div>
          <div
            :class="[
              thinking ? 'invisible' : '',
              'w-full flex items-center justify-center capitalize',
            ]"
          >
            {{ action }}
          </div>
        </button>
      </div>
    </div>
    <!-- /Actions -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { EventBus } from '../../../../../../js/plugins/event-bus.js'
import * as loadingAnimation from '../../../../../../shared/components/loading.json'

export default {
  props: {
    config: { default: null },
  },

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      thinking: false,
      // config/form
      action: this.config?.action || 'delete',
      title: this.config?.title || 'Delete subscriber(s)',
      subtitle: this.config?.subtitle || '',
      // key for subscriber (not list) actions
      subscribers: this.config?.subscribers || [],
      // key for deleting a list
      list: this.config?.list || null,
      // key for removing subscribers
      listId: this.config.listId || null,
    }
  },

  computed: {
    canSubmit() {
      return this.list || !!this.subscribers.length
    },

    payload() {
      // list delete
      if (this.list) {
        return {
          mail_list_id: this.list.id,
        }
      }

      // follower delete/remove from list
      const payload = {
        follower_ids: this.subscribers.map((subscriber) => subscriber.id),
        mail_list_id: this.listId,
      }

      // pass through unique mail list ids separately for Hail sync
      const uniqueMailListIds = [
        ...new Set(
          this.subscribers.flatMap((follower) =>
            follower.lists.map((list) => list.id),
          ),
        ),
      ]

      payload.mail_list_ids = uniqueMailListIds

      return payload
    },
  },

  methods: {
    ...mapActions({
      dispatchDeleteFollowers: 'careerwise/dispatchDeleteFollowers',
      dispatchDeleteMailList: 'careerwise/dispatchDeleteMailList',
      dispatchRemoveFollowersFromList:
        'careerwise/dispatchRemoveFollowersFromList',
    }),

    async onSubmit() {
      if (this.canSubmit) {
        this.$set(this, 'thinking', true)
        if (this.list) {
          await this.dispatchDeleteMailList(this.payload)
        } else if (this.action === 'remove') {
          await this.dispatchRemoveFollowersFromList(this.payload)
        } else {
          await this.dispatchDeleteFollowers(this.payload)
        }
        this.$set(this, 'thinking', false)
        EventBus.$emit('showModal', false)
      }
    },
  },
}
</script>
